import React from "react";

import Form from "antd/es/form";
import { defineMessages, useIntl } from "react-intl";

import CardConfigurationProps from "@app/scene/dashboard/types/CardConfigurationProps";

import Field from "./Field";

const messages = defineMessages({
  expectedCloseDate: {
    id: "dashboard.editModal.dateRange.openStageDealAmount.expectedCloseDate",
    defaultMessage: "Expected Close Date",
    description:
      "Title of the Date range field in a time range form in Edit Open Stage Deal Amount Modal on Dashboard",
  },
});

interface Props extends CardConfigurationProps {}

const DateRangeFormComponent: React.FC<Props> = ({ disabled }) => {
  const intl = useIntl();

  return (
    <div>
      <Form.Item
        label={intl.formatMessage(messages.expectedCloseDate)}
        name={["dateRange", "days"]}
      >
        <Field disabled={disabled} />
      </Form.Item>
    </div>
  );
};

export default DateRangeFormComponent;
